<!--
 * @Description: 搜索及图片搜索商品页面组件
 -->
<template>
  <div class="goods">
    <!-- 分类标签 -->
    <el-card body-style="padding: 0 0;background: #f9f9f9" class="allCategory">
      <el-row class="category">
        <el-col :span="2" class="categoryLabel">市场</el-col>
        <el-col :span="22" class="categoryList">
          <el-menu :default-active="query.area_id" mode="horizontal">
            <el-menu-item index="0">全部</el-menu-item>
            <el-menu-item index="1">五亭龙</el-menu-item>
            <el-menu-item index="2">金山</el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </el-card>
    <!-- 分类标签END -->

    <!-- 面包屑 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>您所在的位置</el-breadcrumb-item>
        <el-breadcrumb-item to="/">绒博汇</el-breadcrumb-item>
        <el-breadcrumb-item>{{ query.keyword }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="totalCount">
        总共<span>{{ total }}</span
        >件商品
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- 面包屑END -->

    <!-- 搜索及分页 -->
    <el-card class="query" body-style="padding: 0 0">
      <el-row class="queryCondition">
        <el-col :span="12" style="height: 40px; line-height: 40px">
          <el-row>
            <el-col :span="4" class="queryTag">浏览量</el-col>
            <el-col :span="4" class="queryTag">下载量</el-col>
            <el-col :span="4" class="queryTag">上新时间</el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-col>
        <el-col :span="12" class="pagination">
          <!-- 分页 -->
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="query.pageSize"
            :total="total"
            @current-change="currentChange"
          ></el-pagination>
          <!-- 分页END -->
        </el-col>
      </el-row>
    </el-card>
    <!-- 搜索及分页END -->

    <!-- 主要内容区 -->
    <div class="main" v-loading="loading" element-loading-text="加载中">
      <div class="list">
        <GoodsList :list="list" v-if="list.length > 0"></GoodsList>
        <div v-else class="none-product">加载中，请稍候</div>
      </div>
      <!-- 底部分页 -->
      <div style="text-align: center">
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="query.pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
        <!-- 分页END -->
      </div>
    </div>
    <!-- 主要内容区END -->
  </div>
</template>
<script>
import GoodsList from "./../components/GoodsList";

export default {
  name: "Search",
  components: {
    GoodsList,
  },
  data() {
    return {
      loading: true,
      list: [], // 商品列表
      total: 0, // 商品总量
      currentPage: 1, //当前页码
      query: {
        page: 1,
        pageSize: 25,
        keyword: "图片搜索", // 搜索条件
      },
    };
  },
  created() {
    if (this.$route.query.data) {
      this.getImageQueryData(this.$route.query.data);
    }
    if (this.$route.query.keyword) {
      this.getKeyWordQueryData(this.$route.query.keyword);
    }
  },
  watch: {
    $route(newV) {
      if (newV.query.data) {
        this.getImageQueryData(newV.query.data);
      }
      if (newV.query.keyword) {
        this.page = 1;
        this.currentPage = 1;
        this.getKeyWordQueryData(newV.query.keyword);
      }
    },
  },
  methods: {
    /**
     * 图片查询数据列表
     * @param {*} goods
     */
    getImageQueryData(goods) {
      const data = JSON.parse(goods);
      this.list = data.list;
      this.total = data.totalCount;
      this.currentPage = 1;
      this.query.keyword = "图片搜索";
      this.loading = false;
    },
    /**
     * 关键字查询数据列表
     */
    async getKeyWordQueryData(keyword) {
      this.query.keyword = keyword;
      if (keyword) {
        const { data } = await this.$axios.post(
          this.$newApi + "/api/rbh/search/keyword",
          this.query
        );
        this.list = data.data.list;
        if (this.query.page === 1) {
          this.total = data.data.totalCount;
        }
        this.loading = false;
      }
    },
    /**
     * 变更页码
     * @param {*} currentPage
     */
    currentChange(currentPage) {
      this.loading = true;
      this.query.page = currentPage;
      this.getKeyWordQueryData(this.query.keyword);
    },
  },
};
</script>

<style scoped>
.el-menu--horizontal {
  height: 50px;
  line-height: 50px;
}
.el-input__inner {
  border: 0 !important;
}
.el-menu--horizontal > .el-menu-item {
  margin: 10px 0;
  height: 30px !important;
  line-height: 30px !important;
  padding: 0 15px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #fff;
  background: #fb4d4f;
  border: 1px solid #fb4d4f;
  border-radius: 1em;
}
.goods {
  background: rgb(246, 246, 246);
  padding: 15px 0;
}
/* 分类标签CSS */
.goods .allCategory {
  width: 1225px;
  font-size: 14px;
  margin: 0 auto;
}
.allCategory .category {
  line-height: 50px;
  height: 50px;
  border: 1px solid #e4e4e4;
}
.category .categoryLabel {
  text-align: center;
  background: rgb(246, 246, 246);
  color: #565656;
}
/* 分类标签CSS END */

/* 面包屑CSS */
.goods .breadcrumb {
  width: 1225px;
  font-size: 14px;
  color: #e4e4e4;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
.goods .breadcrumb .el-breadcrumb {
  height: 40px;
  line-height: 40px;
  width: 1000px;
}
.breadcrumb .totalCount {
  width: 225px;
  color: #000;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  text-align: right;
}
.breadcrumb .totalCount span {
  color: #fb4d4f;
}
/* 面包屑CSS END */

/* 查询 */
.goods .query {
  width: 1225px;
  margin: 0 auto;
}
.query .queryCondition {
  border: 0.5px solid #e4e4e4;
}
.query .queryCondition .queryTag {
  border-right: 1px solid #e4e4e4;
  text-align: center;
  background: #fff;
}
.query .pagination {
  height: 30px;
  line-height: 30px;
  padding: 5px 0;
  text-align: right;
}
/* 查询END */
/* 主要内容区CSS */
.goods .main {
  margin: 0 auto;
  max-width: 1225px;
}
.goods .main .list {
  min-height: 650px;
  padding-top: 14.5px;
  margin-left: -13.7px;
  overflow: auto;
}
.main .list::-webkit-scrollbar {
  width: 0;
  display: none;
}
.goods .main .none-product {
  color: #333;
  margin-left: 13.7px;
}
/* 主要内容区CSS END */
</style>
